import React from "react";

import { useIntl } from "react-intl";

function withUseIntl(Component) {
    return function WrappedComponent(props) {
      const hookValue = useIntl();
      return <Component {...props} useIntl={hookValue} />;
    }
}

export default withUseIntl;